import { fabric } from "fabric";
import { TargetFindLockState } from "../types";

/**
 * =====================================================
 * 目标查找锁定模块
 * =====================================================
 * 用于中键拖拽时禁用 Fabric.js 的对象选择功能
 * 防止拖拽平移时误选中对象
 */

/**
 * 创建目标查找锁定状态
 */
export const createTargetFindLockState = (): TargetFindLockState => ({
  lockCount: 0,
  originalValue: null
});

/**
 * 锁定目标查找 - 阻止 Fabric.js 的对象选择
 * 使用引用计数支持嵌套锁定
 */
export const lockTargetFind = (
  canvas: fabric.Canvas,
  state: TargetFindLockState
): void => {
  const anyCanvas = canvas as any;
  if (state.lockCount === 0) {
    state.originalValue = !!anyCanvas.skipTargetFind;
    anyCanvas.skipTargetFind = true;
  }
  state.lockCount++;
};

/**
 * 解锁目标查找
 * 当引用计数归零时恢复原始状态
 */
export const unlockTargetFind = (
  canvas: fabric.Canvas,
  state: TargetFindLockState
): void => {
  if (state.lockCount === 0) return;
  state.lockCount--;
  if (state.lockCount === 0) {
    const anyCanvas = canvas as any;
    if (state.originalValue !== null) {
      anyCanvas.skipTargetFind = state.originalValue;
    } else {
      anyCanvas.skipTargetFind = false;
    }
    state.originalValue = null;
  }
};

/**
 * 强制重置目标查找状态 - 用于异常恢复
 * 当检测到状态不一致时强制重置
 */
export const forceResetTargetFind = (
  canvas: fabric.Canvas,
  state: TargetFindLockState
): void => {
  if (state.lockCount === 0) {
    const anyCanvas = canvas as any;
    if (anyCanvas.skipTargetFind) {
      anyCanvas.skipTargetFind = false;
      state.originalValue = null;
    }
  }
};
